import styled from 'styled-components';

export const Wrapper = styled.div`
    margin: 10px;
    overflow: hidden;
    width: 96%;
`;

export const Row = styled.div`
    margin: 5px 0;
`;

export const Button = styled.button`
    margin: 0 6px;
`;